import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
    private rowDataSource = new BehaviorSubject<any[]>([]);  // Initialize as empty array
    rowData$ = this.rowDataSource.asObservable();
  
    // Update rowData with new data
    updateRowData(newRowData: any[]) {
      this.rowDataSource.next(Array.isArray(newRowData) ? newRowData : []); // Enforce array format
    }
}
